import axios from "axios";

// Keep in sync with uploadEventItem's fileSize limit in server/routes/uploadRoutes.js.
export const EVENT_MEDIA_MAX_FILE_MB = 200;

/**
 * Upload files one request at a time. Ten files at the per-file limit would
 * exceed nginx's 512 MB request cap, and multer aborts a whole request on one
 * bad file — sending them singly lets the good files through regardless.
 *
 * @returns {Promise<{uploaded: File[], failed: {file: File, message?: string}[]}>}
 */
export async function uploadMediaFiles(url, files, config) {
  const uploaded = [];
  const failed = [];
  for (const file of files) {
    const fd = new FormData();
    fd.append("files", file, file.name);
    try {
      const res = await axios.post(url, fd, config);
      if (res.data?.success) uploaded.push(file);
      else failed.push({ file, message: res.data?.message });
    } catch (err) {
      failed.push({ file, message: err.response?.data?.message || err.message });
    }
  }
  return { uploaded, failed };
}

export const describeUploadFailures = (failed, t) =>
  failed.map(({ file, message }) =>
    t("events.mediaUploadFileFailed", {
      name: file.name,
      reason: message || t("events.errorUploadingMedia"),
    })
  );
